export default __webpack_public_path__ + "static/media/case4-logo.a8c8615f.png";